import { render } from "./Directories.vue?vue&type=template&id=20d817e0&scoped=true"
import script from "./Directories.vue?vue&type=script&lang=js"
export * from "./Directories.vue?vue&type=script&lang=js"

import "./Directories.vue?vue&type=style&index=0&id=20d817e0&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-20d817e0"]])

export default __exports__